import api from '../../lib/api';
import type {
  ImprovementSuggestionSummary,
  ImprovementSuggestionStatus,
  PaginatedImprovementSuggestions,
} from './types';

export interface ListImprovementSuggestionsParams {
  status?: ImprovementSuggestionStatus;
  search?: string;
  page?: number;
  pageSize?: number;
  sortBy?: 'code' | 'title' | 'status' | 'createdAt';
  sortDir?: 'asc' | 'desc';
}

export const fetchImprovementSuggestions = async (
  params: ListImprovementSuggestionsParams = {},
): Promise<PaginatedImprovementSuggestions> => {
  const { data } = await api.get<PaginatedImprovementSuggestions>('improvement-suggestions', {
    params,
  });
  return data;
};

export const fetchImprovementSuggestion = async (
  id: string,
): Promise<ImprovementSuggestionSummary> => {
  const { data } = await api.get<ImprovementSuggestionSummary>(`improvement-suggestions/${id}`);
  return data;
};

export const createImprovementSuggestion = async (payload: {
  title: string;
  description: string;
  responsibleUserId?: number | null;
}): Promise<ImprovementSuggestionSummary> => {
  const { data } = await api.post<ImprovementSuggestionSummary>('improvement-suggestions', payload);
  return data;
};

export const updateImprovementSuggestion = async (
  id: string,
  payload: {
    title?: string;
    description?: string;
    status?: ImprovementSuggestionStatus;
    responsibleUserId?: number | null;
  },
): Promise<ImprovementSuggestionSummary> => {
  const { data } = await api.put<ImprovementSuggestionSummary>(
    `improvement-suggestions/${id}`,
    payload,
  );
  return data;
};

export const escalateImprovementSuggestion = async (
  id: string,
  payload?: { title?: string; description?: string },
): Promise<{ suggestionId: string; qmsRecordId: string }> => {
  const { data } = await api.post<{ suggestionId: string; qmsRecordId: string }>(
    `improvement-suggestions/${id}/escalate`,
    payload ?? {},
  );
  return data;
};
